import { UserRepositoryImpl } from '../Data/UserRepositoryImpl';
import { GetUserDetailsUseCase } from '../Domain/usecases/GetUserDetailsUseCase';
import { UpdateUserUseCase } from '../Domain/usecases/UpdateUserUseCase';
import { PatchUserUseCase } from '../Domain/usecases/PatchUserUseCase';
import { SearchUsersUseCase } from '../Domain/usecases/SearchUsersUseCase';
import { CreateUserUseCase } from '../Domain/usecases/CreateUserUseCase';
import { GetUserUseCase } from '../Domain/usecases/GetUserUseCase';

const repository = new UserRepositoryImpl();

export const userUseCases = {
  getUserDetails: new GetUserDetailsUseCase(repository),
  updateUser: new UpdateUserUseCase(repository),
  patchUser: new PatchUserUseCase(repository),
  searchUsers: new SearchUsersUseCase(repository),
  createUser: new CreateUserUseCase(repository),
  getUser: new GetUserUseCase(repository),
};

